import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import abcjsObj from 'abcjs';

import Grid from '@material-ui/core/Grid';
import Close from '@material-ui/icons/Close';

import { getOptions } from '../../lib/optionsHelper';
import { grid_classes } from '../../lib/classNames';
import { drawLengthSquaresOverNote } from '../../lib/scorePainterHelper';
import { findLyricsByPlayedPath} from '../../lib/noteHelper'

class TutorResults extends PureComponent {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    matcher: PropTypes.object,
    scoreText: PropTypes.string,
    debug: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = getOptions();
    this.state.resultPercent = 50;

    this.parserParams = {};
    this.engraverParams = { responsive: 'resize', add_classes: true };
    this.renderParams = {
      //clickListener: this.onNoteClicked
    };

    this.abcjsCanvasRef = React.createRef();
  }

  componentDidMount() {
    this.renderAbcNotation();
    this.renderMatching();
  }

  componentWillReceiveProps(nextProps) {
    const { scoreText } = nextProps;
    if (scoreText !== this.props.scoreText) {
      this.renderAbcNotation();
      this.renderMatching();
    }
  }

  render() {
    const { onClose } = this.props;
    const { resultPercent } = this.state;
    return (
      <Grid
        className="pitch-detector"
        classes={grid_classes}
        container
        direction="row"
        justify="center"
        alignItems="stretch"
        spacing={40}
      >
        <Grid classes={grid_classes} item xs={10} container direction="column" justify="space-between" spacing={40}>
          <Grid item className="tutorResults-intro">
            <div className="pitch-left">
              Con il Tutor puoi scoprire come
              <br />
              hai eseguito il brano
            </div>
            <div className="pitch-center">
              <div className={'resultPercent' + (resultPercent >= 50 ? ' success' : ' fail')}>{resultPercent}%</div>
              <div className={'resultText' + (resultPercent >= 50 ? ' success' : ' fail')}>
                eseguito
                <br />
                correttamente
              </div>
            </div>
            <div className="pitch-right">
              <button className="Tutor-Close" onClick={onClose}>
                <Close />
              </button>
            </div>
          </Grid>
          <Grid item className="tutorResultsView">
            <div id={'abcjs-results'} style={{ width: '100%' }} ref={this.abcjsCanvasRef} />
          </Grid>
        </Grid>
      </Grid>
    );
  }

  findResultPathByPlayedPath = path => {
    const canvas = this.abcjsCanvasRef.current;
    // prendi i dettagli di path che ci interessano
    const classes = path.className.baseVal;
    // trova il path corrispondente in "abcjs-results"
    const result_paths = canvas.getElementsByClassName(classes);
    if (result_paths.length !== 1) {
      console.log('WARNING found ', result_paths.length, 'nodes:', result_paths);
    }
    if (result_paths.length) {
      const result_path = result_paths[0];
      return result_path;
    }
    return null;
  };

  

  findTotalNotes = () => {
    const canvas = this.abcjsCanvasRef.current;
    return canvas.querySelectorAll('.abcjs-note').length;
  };

  renderMatching() {
    if (this.props.matcher === null) return;

    const matcher = this.props.matcher;
    let matchedPlayedNotes = 0;

    // reset matcher:
    matcher.lastListenedIndex = 0;
    matcher.lastPlayedIndex = 0;
    // match:
    matcher.matcherLogic((path, rightLength) => {}, path => {}, true);

    matchedPlayedNotes = 0;
    matcher.playedNotes.forEach((note, idx) => {
      const { path } = note;
      const resultPath = this.findResultPathByPlayedPath(path);
      if (resultPath) {
        if (note.matches) {
          // Le note che sono già state colorate non le calcolo per le giuste.
          // Cosi' se è già verde sono a posto (cioè, è già corretta).
          // Se invece era rossa la devo considerare sbagliata
          if (resultPath.getAttribute('fill') === '#000000') {
            resultPath.setAttribute('fill', '#8CDB03');
            matchedPlayedNotes++;
            const lyricPath = findLyricsByPlayedPath(this.abcjsCanvasRef.current,path);
            if (lyricPath) {
              lyricPath.remove();
            }
          }
        } else {
          resultPath.setAttribute('fill', 'red');
        }
        if (!note.listenedFound) {
          resultPath.classList.add('tutor-results-add-squares');
          const lyricPath = findLyricsByPlayedPath(this.abcjsCanvasRef.current,path);
          if (lyricPath) {
            lyricPath.remove();
          }
        }
      }
    });
    const percent = Math.floor((matchedPlayedNotes * 100) / this.findTotalNotes());

    const canvas = this.abcjsCanvasRef.current;
    const paper = this.tunes[0].engraver.renderer.paper;
    const shouldAddSquares = this.abcjsCanvasRef.current.querySelectorAll('.tutor-results-add-squares');
    shouldAddSquares.forEach(path => {
      drawLengthSquaresOverNote(canvas, paper, path);
    });

    this.setState({ resultPercent: percent });
  }

  renderAbcNotation() {
    const scoreText = this.props.scoreText;
    this.tunes = abcjsObj.renderAbc(
      'abcjs-results',
      scoreText,
      this.parserParams,
      this.engraverParams,
      this.renderParams
    );
  }
}

export default TutorResults;
